import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../redux/action_creators';
import { post_api, get_api } from '../../../../redux/api_funcs';
import { get_api_url } from '../../../../utils/urls';
import CommonHeader from '../../../util_components/common_header';

class TranscriptionStatus extends Component {
  state = {
    loading: false,
    jobs: [],
    retrying: {},
    starting_node: false
  };

  componentDidMount() {
    this.fetch_jobs();
  }

  fetch_jobs = () => {
    this.setState({ loading: true });
    const url = get_api_url('/v2/transcription/jobs', false, true);
    get_api(url, true)
      .then((resp) => {
        const jobs = resp?.data?.jobs || [];
        this.setState({ loading: false, jobs });
      })
      .catch((e) => {
        const msg = e?.response?.data?.message || 'Failed to fetch transcription jobs.';
        this.setState({ loading: false });
        this.props.set_notification_variable(true, 'error', msg);
      });
  };

  retry_job = (session_uuid) => {
    this.setState((prev) => ({ retrying: { ...prev.retrying, [session_uuid]: true } }));
    const url = get_api_url(`/v2/transcription/jobs/${session_uuid}/retry`, false, true);
    post_api(url, {}, true)
      .then(() => {
        this.setState((prev) => ({ retrying: { ...prev.retrying, [session_uuid]: false } }));
        this.props.set_notification_variable(true, 'success', `Re-transcription queued for ${session_uuid}.`);
        this.fetch_jobs();
      })
      .catch((e) => {
        const msg = e?.response?.data?.message || 'Failed to queue retry.';
        this.setState((prev) => ({ retrying: { ...prev.retrying, [session_uuid]: false } }));
        this.props.set_notification_variable(true, 'error', msg);
      });
  };

  start_gpu_node = () => {
    this.setState({ starting_node: true });
    const url = get_api_url('/v2/transcription/node/start', false, true);
    post_api(url, {}, true)
      .then(() => {
        this.setState({ starting_node: false });
        this.props.set_notification_variable(true, 'success', 'GPU node start request sent.');
      })
      .catch((e) => {
        const msg = e?.response?.data?.message || 'Failed to start GPU node.';
        this.setState({ starting_node: false });
        this.props.set_notification_variable(true, 'error', msg);
      });
  };

  render_table = () => {
    const { jobs, retrying } = this.state;
    if (jobs.length === 0) {
      return (
        <div style={{ padding: '40px 0', color: '#94a3b8', fontSize: '13px' }}>
          No transcription jobs found.
        </div>
      );
    }
    const cols = [
      { key: 'session_uuid', label: 'Session UUID' },
      { key: 'teacher_name', label: 'Teacher' },
      { key: 'student_name', label: 'Student' },
      { key: 'status', label: 'Status' },
      { key: 'attempts', label: 'Attempts' },
      { key: 'needs_review', label: 'Needs Review' },
      { key: 'last_error', label: 'Last Error' },
      { key: 'actions', label: '' }
    ];
    return (
      <div style={{ overflowX: 'auto', marginTop: '16px' }}>
        <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: '12.5px' }}>
          <thead>
            <tr style={{ background: '#f1f5f9' }}>
              {cols.map((c) => (
                <th
                  key={c.key}
                  style={{
                    padding: '8px 12px',
                    textAlign: 'left',
                    fontWeight: 600,
                    borderBottom: '2px solid #e2e8f0',
                    whiteSpace: 'nowrap',
                    color: '#475569',
                    fontSize: '11px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}
                >
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {jobs.map((job, i) => {
              const is_retrying = !!retrying[job.session_uuid];
              return (
                <tr key={job.session_uuid || i} style={{ background: i % 2 === 0 ? '#fff' : '#f8fafc' }}>
                  <td style={{ padding: '7px 12px', borderBottom: '1px solid #f1f5f9', fontFamily: 'monospace', fontSize: '11px', maxWidth: '160px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {job.session_uuid}
                  </td>
                  <td style={{ padding: '7px 12px', borderBottom: '1px solid #f1f5f9' }}>{job.teacher_name || '—'}</td>
                  <td style={{ padding: '7px 12px', borderBottom: '1px solid #f1f5f9' }}>{job.student_name || '—'}</td>
                  <td
                    style={{
                      padding: '7px 12px',
                      borderBottom: '1px solid #f1f5f9',
                      fontWeight: 600,
                      color:
                        job.status === 'completed'
                          ? '#16a34a'
                          : job.status === 'failed'
                          ? '#dc2626'
                          : job.status === 'processing'
                          ? '#d97706'
                          : '#334155'
                    }}
                  >
                    {job.status}
                  </td>
                  <td style={{ padding: '7px 12px', borderBottom: '1px solid #f1f5f9', textAlign: 'center' }}>{job.attempts ?? '—'}</td>
                  <td style={{ padding: '7px 12px', borderBottom: '1px solid #f1f5f9', textAlign: 'center' }}>
                    {job.needs_review ? (
                      <span style={{ color: '#d97706', fontWeight: 600 }}>Yes</span>
                    ) : (
                      <span style={{ color: '#94a3b8' }}>No</span>
                    )}
                  </td>
                  <td
                    style={{
                      padding: '7px 12px',
                      borderBottom: '1px solid #f1f5f9',
                      maxWidth: '240px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      color: '#ef4444',
                      fontSize: '12px'
                    }}
                    title={job.last_error || ''}
                  >
                    {job.last_error || '—'}
                  </td>
                  <td style={{ padding: '7px 12px', borderBottom: '1px solid #f1f5f9', whiteSpace: 'nowrap' }}>
                    <button
                      onClick={() => this.retry_job(job.session_uuid)}
                      disabled={is_retrying}
                      style={{
                        padding: '4px 12px',
                        background: is_retrying ? '#e2e8f0' : '#2563eb',
                        color: is_retrying ? '#94a3b8' : '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        fontSize: '12px',
                        fontWeight: 600,
                        cursor: is_retrying ? 'not-allowed' : 'pointer'
                      }}
                    >
                      {is_retrying ? 'Queuing...' : 'Re-transcribe'}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  render() {
    const { loading, starting_node } = this.state;
    return (
      <CommonHeader title="Transcription Status" loading={loading}>
        <div style={{ padding: '16px 0' }}>
          <div style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
            <button
              onClick={this.fetch_jobs}
              disabled={loading}
              style={{
                padding: '7px 16px',
                background: loading ? '#e2e8f0' : '#2563eb',
                color: loading ? '#94a3b8' : '#fff',
                border: 'none',
                borderRadius: '6px',
                fontWeight: 600,
                fontSize: '13px',
                cursor: loading ? 'not-allowed' : 'pointer'
              }}
            >
              {loading ? 'Loading...' : 'Refresh'}
            </button>
            <button
              onClick={this.start_gpu_node}
              disabled={starting_node}
              style={{
                padding: '7px 16px',
                background: starting_node ? '#e2e8f0' : '#16a34a',
                color: starting_node ? '#94a3b8' : '#fff',
                border: 'none',
                borderRadius: '6px',
                fontWeight: 600,
                fontSize: '13px',
                cursor: starting_node ? 'not-allowed' : 'pointer'
              }}
            >
              {starting_node ? 'Starting...' : 'Start GPU Node'}
            </button>
          </div>
          {this.render_table()}
        </div>
      </CommonHeader>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  set_notification_variable: (show, type, msg) =>
    dispatch(actions.set_notification_variable(show, type, msg))
});

export default connect(null, mapDispatchToProps)(TranscriptionStatus);
